export default __webpack_public_path__ + "images/student/avatars/Eddy-864ca42cf29ce8fff6ae442ecb5636b5.png";